
import { defineComponent } from "vue";
import DoctorsList from "@/components/Departments/common/DoctorsListTemplate3.vue";
import { DepartmentPropDataInterface } from "@/ts/interfaces";

export default defineComponent({
  data(): DepartmentPropDataInterface {
    return {
      name: "Dermatology Doctors",
      queryName: "Dermatology",
      teamName: "Dermatology team",
    };
  },
  components: { DoctorsList },
});
